import { ClickHereNOwIon, DoubleRightArrowIcon } from '@/svgs'
import Link from 'next/link'
import React from 'react'

export default function TechNServicesHeroSection({
   title,
   subtitle,
   description,
   tags = [],
   HeroIcon
}) {
   return (
      <section className="cs-bg-secondary first-section">
         <div className="container">
            <div className="g-4 row align-items-center">
               <div className="col-xl-7 position-relative">
                  <h1 dangerouslySetInnerHTML={{ __html: title }} className="intro_title"></h1>
                  <p className="intro_sub_titel">{subtitle}</p>
                  <p className="intro_description">{description}</p>

                  <div className="d-flex flex-wrap gap-2 mb-4">
                     {tags.map((tag, index) => (
                        <div
                           key={index}
                           className="d-inline-block rounded-pill intro_tag cs-bg-theme-color-2 cs-font-secondary cs-text-primary px-4 py-2"
                        >
                           {tag}
                        </div>
                     ))}
                  </div>

                  <Link
                     href="/discover-benzatine/contact-us"
                     className="btn bez-fill-btn"
                  >
                     Consult our AI experts
                     <DoubleRightArrowIcon />
                  </Link>

                  <div className="d-xxl-flex justify-content-center d-none click-here-svg">
                     <ClickHereNOwIon />
                  </div>
               </div>
               <div className="col-xl-5 d-flex justify-content-center">
                  <div className="rounded-5 text-white cs-bg-primary cs-font-secondary px-5 py-lg-5 py-md-3 teq-first-section-svg">
                    <HeroIcon/>
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}
